import React, { Component } from 'react';
import { Table,  Button,  } from 'semantic-ui-react';


class PayItemRow extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }

    payItem = () => {
        this.props.makePayment(this.props.item);
    }

    
    render() { 
        return ( <div>
            <Table.Cell><Button onClick={this.payItem} color='red'>PAY</Button></Table.Cell>
        </div> );
    }
}
 
export default PayItemRow;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/PayItemRow.js